import React from "react";
import styled from "@emotion/styled";
import { ClearedStyleHref } from "@modules/Components";

const MainContent = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: center;
  margin-bottom: 135px;
  grid-row-gap: 86px;
  grid-column-gap: 10px;

  @media (max-width: 1450px) {
    grid-template-columns: repeat(5, auto);
  }
  @media (max-width: 1200px) {
    margin-bottom: 105px;
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 800px) {
    margin-bottom: 105px;
    grid-template-columns: repeat(2, 1fr);
  }
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const LogoImage = styled.img`
  cursor: pointer;
  height: 37px;
  width: auto;
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }

  @media (max-width: 1450px) {
    max-width: 100%;
  }
  @media (max-width: 800px) {
    height: 24px;
  }
`;

const LargeScreen = styled.div`
  @media (max-width: 1200px) {
    display: none;
  }
`;

const TabletScreen = styled.div`
  @media (min-width: 1201px) {
    display: none;
  }
  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileScreen = styled.div`
  @media (min-width: 801px) {
    display: none;
  }
`;

const logoArray = [
  {
    link: "https://cdn.cardcash.com/website/ui/exchange_lp/logos/amazon-logo-dark.png",
    display: 1,
    website: "https://www.cardcash.com/amazon/"
  },
  {
    link: "https://cdn.cardcash.com/website/ui/exchange_lp/logos/mastercard-logo.svg",
    display: 1,
    website: "https://mastercard.cardcash.com/"
  },
  {
    link: "https://cdn.cardcash.com/website/ui/exchange_lp/logos/cvs-logo.svg",
    display: 3,
    website: "https://cvs.cardcash.com/"
  },
  {
    link: "https://cdn.cardcash.com/website/ui/exchange_lp/logos/walmart-logo.svg",
    display: 1,
    website: "https://www.cardcash.com/sell/"
  },
  {
    link: "https://cdn.cardcash.com/website/ui/exchange_lp/logos/wayfair-logo-dark.png",
    display: 1,
    website: "https://wayfair.cardcash.com/"
  },
  {
    link: "https://cdn.cardcash.com/website/ui/exchange_lp/logos/mercari_logo.svg",
    display: 3,
    website: ""
  },
  {
    link: "https://cdn.cardcash.com/website/ui/exchange_lp/logos/uber-logo-dark.png",
    display: 2,
    website: "https://uber.cardcash.com/"
  },
  {
    link: "https://cdn.cardcash.com/website/ui/exchange_lp/logos/hotels-logo-dark.png",
    display: 3,
    website: "https://hotels.cardcash.com/"
  },
  {
    link: "https://cdn.cardcash.com/website/ui/exchange_lp/logos/ebay-logo-dark.png",
    display: 2,
    website: "https://ebay.cardcash.com/"
  },
  {
    link: "https://cdn.cardcash.com/website/ui/exchange_lp/logos/united-airlines-logo.svg",
    display: 3,
    website: "https://united.cardcash.com/"
  }
];

const ExchangeLogos = ({}) => {
  return (
    <>
      <LargeScreen>
        <MainContent>
          {logoArray.map((item, index) => (
            <ImageContainer key={index}>
              <ClearedStyleHref href={item.website} target="_blank">
                <LogoImage src={item.link} alt={`exchange`} />
              </ClearedStyleHref>
            </ImageContainer>
          ))}
        </MainContent>
      </LargeScreen>
      <TabletScreen>
        <MainContent>
          {logoArray
            .filter(item => item.display <= 2)
            .map((item, index) => (
              <ImageContainer key={index}>
                <ClearedStyleHref href={item.website} target="_blank">
                  <LogoImage src={item.link} alt="exchange" />
                </ClearedStyleHref>
              </ImageContainer>
            ))}
        </MainContent>
      </TabletScreen>
      <MobileScreen>
        <MainContent>
          {logoArray
            .filter(item => item.display <= 1)
            .map((item, index) => (
              <ImageContainer key={index}>
                <ClearedStyleHref href={item.website} target="_blank">
                  <LogoImage src={item.link} alt="exchange" />
                </ClearedStyleHref>
              </ImageContainer>
            ))}
        </MainContent>
      </MobileScreen>
    </>
  );
};

export default ExchangeLogos;
